// https://etherscan.io/address/0xEd42a7D8559a463722Ca4beD50E0Cc05a386b0e1
export const CROSS_CHAIN_CONTROLLER = '0xEd42a7D8559a463722Ca4beD50E0Cc05a386b0e1';

// IGovernanceCore https://etherscan.io/address/0x9AEE0B04504CeF83A65AC3f0e838D0593BCb2BC7
export const GOVERNANCE = '0x9AEE0B04504CeF83A65AC3f0e838D0593BCb2BC7';

// IPayloadsControllerCore https://etherscan.io/address/0xdAbad81aF85554E9ae636395611C58F7eC1aAEc5
export const PAYLOADS_CONTROLLER = '0xdAbad81aF85554E9ae636395611C58F7eC1aAEc5';

// https://etherscan.io/address/0x06a1795a88b82700896583e123F46BE43877bFb6
export const VOTING_MACHINE = '0x06a1795a88b82700896583e123F46BE43877bFb6';

// https://etherscan.io/address/0x6ACe1Bf22D57a33863161bFDC851316Fb0442690
export const VOTING_PORTAL_ETH_ETH = '0x6ACe1Bf22D57a33863161bFDC851316Fb0442690';

// https://etherscan.io/address/0x9Ded9406f088C10621BE628EEFf40c1DF396c172
export const VOTING_PORTAL_ETH_AVAX = '0x9Ded9406f088C10621BE628EEFf40c1DF396c172';

// https://etherscan.io/address/0xFe4683C18aaad791B6AFDF0a8e1Ed5C6e2c9ecD6
export const VOTING_PORTAL_ETH_POL = '0xFe4683C18aaad791B6AFDF0a8e1Ed5C6e2c9ecD6';

// https://etherscan.io/address/0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A
export const PC_DATA_HELPER = '0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A';

// https://etherscan.io/address/0x971c82c8316aD611904F95616c21ce90837f1856
export const GOV_DATA_HELPER = '0x971c82c8316aD611904F95616c21ce90837f1856';

// https://etherscan.io/address/0x77976B51569896523EE215962Ee91ff236Fa50E8
export const VM_DATA_HELPER = '0x77976B51569896523EE215962Ee91ff236Fa50E8';

// https://etherscan.io/address/0x94363B11b37BC3ffe43AB09cff5A010352FE85dC
export const META_DELEGATE_HELPER = '0x94363B11b37BC3ffe43AB09cff5A010352FE85dC';

// https://etherscan.io/address/0x73C6Fb358dDA8e84D50e98A98F7c0dF32e15C7e9
export const EMERGENCY_REGISTRY = '0x73C6Fb358dDA8e84D50e98A98F7c0dF32e15C7e9';

// https://etherscan.io/address/0xa198Fac58E02A5C5F8F7e877895d50cFa9ad1E04
export const GOVERNANCE_POWER_STRATEGY = '0xa198Fac58E02A5C5F8F7e877895d50cFa9ad1E04';

// https://etherscan.io/address/0x4457cA11E90f416Cc1D3a8E1cA41C0cdEcC251d4
export const GRANULAR_GUARDIAN = '0x4457cA11E90f416Cc1D3a8E1cA41C0cdEcC251d4';

// https://etherscan.io/address/0xCe52ab41C40575B072A18C9700091Ccbe4A06710
export const GOVERNANCE_GUARDIAN = '0xCe52ab41C40575B072A18C9700091Ccbe4A06710';

// https://etherscan.io/address/0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A
export const EXECUTOR_LVL_1 = '0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A';

// https://etherscan.io/address/0x17Dd33Ed0e3dD2a80E37489B8A63063161BE6957
export const EXECUTOR_LVL_2 = '0x17Dd33Ed0e3dD2a80E37489B8A63063161BE6957';

// IVotingStrategy https://etherscan.io/address/0xA16044F268d84599e58E851b25f4DBA061DC6088
export const VOTING_STRATEGY = '0xA16044F268d84599e58E851b25f4DBA061DC6088';

// IDataWarehouse https://etherscan.io/address/0xa638c14525CAEE8e498A67b409CCb1B7b34c3981
export const DATA_WAREHOUSE = '0xa638c14525CAEE8e498A67b409CCb1B7b34c3981';

export const CHAIN_ID = 1;
